<template>
  <section class="multimedia-section my-20">
    <Container>
      <div 
        class="grid gap-0.5 bg-gray-100 p-0.5 mx-auto md:max-w-fit"
        :class="{
          [`grid-cols-1 md:grid-cols-${items.length}`]: true
        }"
      >
        <div 
          v-for="item in items" :key="item.value" 
          class="h-full"
          :class="{
            [`-mx-0.25 -mt-0.25`]: activeItem.value === item.value,
          }"
          :style="{
            height: activeItem.value === item.value ? 'calc(100% + 2px)' : '100%'
          }"
        >
          <button 
            class="text-xl! cursor-pointer bg-white h-full w-full px-4 py-2 font-light"
            :data-scroll-name="item.value"
            :class="{
              'text-white! bg-[var(--bg-primary-color)]!': !getPrimaryColor && activeItem.value === item.value,
              [`text-white! bg-[${getPrimaryColor}]!`]: getPrimaryColor && activeItem.value === item.value,
              'text-gray-500!': activeItem.value !== item.value
            }"
            @click="setActiveItem(item)"
          >
            {{ item.label }}
          </button>
        </div>
      </div>
      <div class="mt-10">
        <div class="w-full">
          <div class="overflow-hidden">
            <component :is="activeItem.component" />
          </div>
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Container from '../../components/Container';

  export default {
    name: 'MultimediaSection',
    props: {
      items: {
        type: Array // [{ value, label, component }]
      },
      itemValue: {
        type: String
      }
    },
    components: {
      Container,
    },
    data () {
      return {
        activeItem: this.items[0],
      }
    },
    computed: {
      ...mapGetters('tour', ['getPrimaryColor']),
    },
    methods: {
      setActiveItem (item) {
        this.activeItem = item;
      }
    },
    watch: {
      itemValue () {
        const matchedItem = this.items.find(item => item.value === this.itemValue);

        if (matchedItem) {
          this.activeItem = matchedItem; 
        }
      }
    }
  };
</script>

<style>
  .multimedia-section {
    .hmt-video-wrapper {
      margin-bottom: 0;
    }
  }
</style>
